import { createTheme } from '@mui/material/styles';

export const theme = (mode: 'light' | 'dark') => createTheme({
  palette: { mode, primary: { main: '#635bff' }, background: { default: mode === 'light' ? '#f7f8fc' : '#10121a', paper: mode === 'light' ? '#ffffff' : '#191d27' } },
  shape: { borderRadius: 10 },
  typography: { fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif', h4: { fontWeight: 700 } },
  components: { MuiButton: { defaultProps: { disableElevation: true } }, MuiCard: { styleOverrides: { root: { boxShadow: mode === 'light' ? '0 2px 12px rgba(21, 24, 38, .06)' : 'none' } } } }
});
